<template>
  <div class="customer-edit-container">
      <Breadcrumb :company="company_uid" :project="user_project" lastname="Edit Customer"/>    
      <CompanyRailsbankForm :formData="customerForm" v-if="customerForm && venderType === 'railsbank' && customerForm.type === 'company'" />
      <PersonalRailsbankForm :formData="customerForm" v-if="customerForm && venderType === 'railsbank' && customerForm.type === 'person'" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Breadcrumb from "@/components/Breadcrumb";
import PersonalRailsbankForm from './components/personal-railsbank-form.vue'
import CompanyRailsbankForm from './components/company-railsbank-form.vue'

import {
  getCustomerBy,
} from "@/api/v2/customer";
export default {

    components: {
        Breadcrumb,
        PersonalRailsbankForm,
        CompanyRailsbankForm,
    },
     computed:{
    ...mapGetters(['user_project','company_uid', 'company_name'])
  },
    data(){
        return {
            venderType: "railbank",
            customerForm: null
        }
    },
    methods:{
    
        getDataToEdit(uid) {
            const loading = this.$notifyloading("Loading data...");
            getCustomerBy(uid).then(({ result, data }) => {
                loading.close();
                if (result) {
                    this.customerForm = data
                    this.venderType = data.vender_type || "railsbank";
                    
                }
            });
        },
    },
    mounted(){
        this.getDataToEdit(this.$route.params.uid);
    },
    
}
</script>

<style>

</style>